import React from 'react';
import { $logger } from '../../controllers/logger/logger.js';
import { ErrorBoundary } from '../error-boundary.js';

/**
 * 自动刷新的异步组件，目前promise会在mount的时候执行一次
 */
function promiseElementHOC(wrappedComponent, loadingUI) {
    class PromiseElementHOC extends React.Component {
        constructor(props) {
            super(props);
            this.promiseCanceled = true;
            this.state = {
                promiseResult: undefined,
                promiseResolved: false,
            };
        }
        settlePromise() {
            wrappedComponent
                .then((result) => {
                if (!this.promiseCanceled) {
                    this.setState({ promiseResult: result, promiseResolved: true });
                }
            })
                .catch((error) => {
                $logger.error(error);
            });
        }
        componentDidMount() {
            this.promiseCanceled = false;
            this.settlePromise();
        }
        componentWillUnmount() {
            this.promiseCanceled = true;
        }
        render() {
            if (!this.state.promiseResolved) {
                return (React.createElement(ErrorBoundary, null, null));
            }
            const element = this.state.promiseResult;
            return (React.createElement(ErrorBoundary, null, element !== null && element !== void 0 ? element : null));
        }
    }
    return React.createElement(PromiseElementHOC, null);
}

export { promiseElementHOC };
//# sourceMappingURL=promise-element-hoc.js.map
